import React from 'react';

import { Divider } from '@mui/material';
import { Moment } from 'moment';
import classNames from 'classnames';

import classes from './CostBreakdownModal.module.scss';
import { LbModal } from '../../../../../../../shared/components/modals';
import { SelfBillingNextPaymentInfo } from '../../../../../../interfaces/selfBillingNextPaymentInfo';
import { getFormattedDate } from '../../../../../../../shared/utils/dateUtils';
import { localDateTimeFormat } from '../../../../../../../shared/constants/apiDateFormat';
import { getPriceView } from '../../../../../../../shared/utils/stringUtils';

type CostBreakdownModalProps = {
  open: boolean;
  nextPaymentInfo: SelfBillingNextPaymentInfo;
  initInfoDate: Moment;
  onClose: () => void;
};

const CostBreakdownModal = ({
  open,
  nextPaymentInfo,
  initInfoDate,
  onClose,
}: CostBreakdownModalProps) => {
  return (
    <LbModal
      open={open}
      title="Cost Breakdown"
      text={`Data is accurate on ${getFormattedDate(initInfoDate, localDateTimeFormat)}`}
      secondaryBtnConfig={{ text: 'Close', onClick: onClose }}
    >
      <div className={classes.box}>
        <Divider flexItem />
        <div className={classes.clientFee}>
          <span>Active Client Fee</span>
          <span className="private-info">
            {getPriceView(nextPaymentInfo.activeClientFeeTotal)}
          </span>
          <span className={classNames(classes.description, 'private-info')}>
            {`${nextPaymentInfo.activeClients} Clients x  ${getPriceView(
              nextPaymentInfo.activeClientFee,
            )}`}
          </span>
        </div>
        <Divider flexItem />
        <div className={classes.extraInfoRow}>
          <span>Subtotal</span>
          <span className="private-info">
            {getPriceView(nextPaymentInfo.activeClientFeeTotal)}
          </span>
        </div>
        <div className={classes.extraInfoRow}>
          <span>SaaS Tax, {nextPaymentInfo.saasTax.taxRate}%</span>
          <span className="private-info">
            {getPriceView(nextPaymentInfo.saasTax.taxAmount)}
          </span>
        </div>
        <Divider flexItem />
        <div className={classes.totalRow}>
          <span>Estimated Upcoming Total</span>
          <span className="private-info">
            {getPriceView(nextPaymentInfo.upcomingTotal)}
          </span>
        </div>
      </div>
    </LbModal>
  );
};

export { CostBreakdownModal };
